import "../../styles/homepage/homepage.scss";
import '../general/language-banner.js';
import { createThemedDestinationsLazyInitializer } from "./components/themed-destinations.js";
import './components/recent-searches.js';
import axios from "axios";
import Swiper from "swiper"

// import Hammer from "hammerjs"; TODO: hot or not swiper
const { is_mobile_device } = window.tg;
require('bootstrap.native');

// If IE or mobile, disable looping in Swiper
let disableLooping = false;
let ua = window.navigator.userAgent;
if (ua.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    disableLooping = true;
}

let doc_width = windowWidth();

let sm_categories = [];
let sm_category_num_items = [];


const blurryImageElements = document.querySelectorAll(".pure-img.blurry-image");

blurryImageElements.forEach(blurryImageEl => {
    doBlurLoadOne(blurryImageEl);
});


// Do async calls to get more homepage content snippets and then initialize swiper for them
let initial_params = ['upcoming-bookings', 'quotes-and-enquiries', 'favourites', 'as-featured-in'];
let additional_params = ['recently-viewed', 'featured-specials'];
async_renderSnippets(initial_params, additional_params);
window.addEventListener("resize", resizeSwiperHandler);
window.addEventListener("load", resizeSwiperHandler);

const initializeThemedDestinationsSwiper = createThemedDestinationsLazyInitializer();

function initializeSwiper(category, num_items) {
    let swiperEl = document.getElementById(category);

    if (!swiperEl) {
        return
    }

    if (swiperEl.querySelectorAll('.swiper-button-next')[0] !== undefined) {
        swiperEl.querySelectorAll('.swiper-button-next')[0].classList.add("btn-next-" + category)
    }
    if (swiperEl.querySelectorAll('.swiper-button-prev')[0] !== undefined) {
        swiperEl.querySelectorAll('.swiper-button-prev')[0].classList.add("btn-prev-" + category)
    }

    if (swiperEl.querySelectorAll('.swiper-pagination')[0] !== undefined) {
        swiperEl.querySelectorAll('.swiper-pagination')[0].classList.add("swiper-pagination-" + category)
    }

    let swiperContainer = swiperEl.getElementsByClassName('swiper-container')[0];

    let swiperConfig = {
        spaceBetween: 16,
        loop: (((num_items > 3) && !disableLooping) || category === 'not-to-brag'),
        centeredSlides: false,
        slidesPerView: "auto",
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        grabCursor: false,
        watchSlidesProgress: true,
        passiveListeners: true,
        shortSwipes: is_mobile_device,
        navigation: {
            nextEl: `${'.btn-next-' + category}`,
            prevEl: `${'.btn-prev-' + category}`,
        }
    };

    if (swiperContainer.classList.contains('disable-looping')) {
        swiperConfig.loop = false;
    }

    new Swiper('#' + category + ' .swiper-container', Object.assign(swiperConfig));
}

function resizeSwiperHandler(e) {
    e.preventDefault();
    let doc_width_n = window.innerWidth;

    // Enable/disable swiper slides - Change flex box to swiper slides on smaller devices
    const locationsGrid = document.getElementById('locations-grid');
    if (locationsGrid) {
        if (doc_width_n > 609) {
            if (locationsGrid.classList.contains('swiper-container')) {
                locationsGrid.classList.remove('swiper-container');
            }
        } else {
            if (!locationsGrid.classList.contains('swiper-container')) {
                locationsGrid.classList.add('swiper-container');

                // Unorthodox use of for loop conventions here is purely for performance - length doesn't have to be recalculated on each iteration
                for (let i = 0, ilen = sm_categories.length; i < ilen; i++) {
                    initializeSwiper(sm_categories[i], sm_category_num_items[i]);
                }
            }
        }
    }

    // // Multi-row swiper slides - Change to single row on smaller devices
    // const swiperContainerNotMobileElements = document.querySelectorAll(".swiper-container:not(.swiper-mobile)");
    // swiperContainerNotMobileElements.forEach(swiperContainerNotMobileEl => {
    //
    //     let swiper = swiperContainerNotMobileEl.swiper;
    //     if (doc_width_n < 609 && swiper.params.slidesPerColumn > 1) {
    //         swiper.wrapperEl.classList.remove('swiper-container-multirow');
    //         swiper.slides.setAttribute('style', '');
    //         swiper.wrapperEl.classList.add('increaseRows');
    //         swiper.update();
    //     } else if (doc_width_n > 609 && swiper.wrapperEl.classList.contains('increaseRows')) {
    //         swiper.params.slidesPerColumn = 2;
    //         swiper.wrapperEl.classList.add('swiper-container-multirow');
    //         swiper.slides.setAttribute('style', '-moz-box-ordinal-group: 0; order: 0; margin-right: 10px;');
    //         swiper.update();
    //     }
    // });
}

function async_renderSnippets(initial_params, additional_params) {
    for (let i = 0, ilen = initial_params.length; i < ilen; i++) {
        let value = initial_params[i];
        let post_params = { 'action': value };
        let url = '/backend/home/generate_snippets/' + value;
        axios.get(url, {
            params: post_params
        }).then(function (response) {
            let data = response.data;
            if (data.success === true) {
                // Add HTML element to the DOM
                let snippetContainerEl = document.getElementById("snippet-container-" + data.id);

                if (snippetContainerEl != null) {
                    snippetContainerEl.innerHTML = data.html;
                    initializeSwiper(data.id, data.num_items);
                }
            }

            if ((response.status === 200 || data.success === true) && data.type === 'as-featured-in') {
                for (let j = 0, jlen = additional_params.length; j < jlen; j++) {
                    let value = additional_params[j];
                    let post_params = { 'action': value };
                    let url = '/backend/home/generate_snippets/' + value;
                    axios.get(url, {
                        params: post_params
                    }).then(function (response) {
                        let data = response.data;
                        if (data.success == true) {
                            let snippetContainerEl = document.getElementById("snippet-container-" + data.id);

                            if (snippetContainerEl != null) {
                                snippetContainerEl.innerHTML = data.html;
                                initializeSwiper(data.id, data.num_items);
                            }
                        }
                    });
                }
            }
        });
    }
}

// Helper functions
/**
 * Function to determine document width
 * @returns {number} The width of the document.
 */
function windowWidth() {
    var docElemProp = window.document.documentElement.clientWidth,
        body = window.document.body;
    return window.document.compatMode === "CSS1Compat" && docElemProp || body && body.clientWidth || docElemProp;
}


function doBlurLoadOne(v) {
    var img = new Image();
    img.onload = function () {
        if (v.nodeName === "DIV") {
            v.style['background-image'] = "url('" + v.getAttribute("data-src"); + "')";
        } else {
            v.src = v.getAttribute("data-src");
        }

        v.style['transition'] = '0.3s filter ease';
        v.style['filter'] = 'blur(0px)';
    }
    v.classList.remove("blurry-image");
    img.src = v.getAttribute("data-src");
}

// Lazy loading of background images
function handleLazyBackgroundIntersection(entries) {
    entries.map((entry) => {
        if (entry.isIntersecting) {
            // entry.target.src = entry.target.dataset.src;
            entry.target.classList.remove('lazy-background');
            lazyBackgroundObserver.unobserve(entry.target);
        }
    });
}

const lazyBackgroundObserver = new IntersectionObserver(handleLazyBackgroundIntersection);
const lazyBackgroundElements = document.querySelectorAll(".lazy-background");
lazyBackgroundElements.forEach((lazyBackgroundEl) => {
    lazyBackgroundObserver.observe(lazyBackgroundEl);
});

// Initialize existing homepage snippets which are swiper(-able) containers.
function handleLazySwiperIntersection(entries) {
    entries.map((entry) => {
        if (entry.isIntersecting) {
            let swiperContainerEl = entry.target;

            if (swiperContainerEl.classList.contains('swiper-mobile') && doc_width > 609) {
                sm_categories.push(swiperContainerEl.parentElement.getAttribute('id'));
                sm_category_num_items.push(swiperContainerEl.querySelectorAll('.swiper-slide').length);
                return true;
            }

            let id = swiperContainerEl.parentElement.getAttribute('id');
            switch (id) {
                case "themed-destinations": {
                    initializeThemedDestinationsSwiper(swiperContainerEl);
                } break;

                default: {
                    let num_items = swiperContainerEl.querySelectorAll('.swiper-slide').length;
                    initializeSwiper(id, num_items);
                } break;
            }

            lazySwiperObserver.unobserve(entry.target);
        }
        return true
    });
}

const lazySwiperObserver = new IntersectionObserver(handleLazySwiperIntersection, { rootMargin: '200px'} );
const lazySwipersEl = document.querySelectorAll(".swiper-container");
lazySwipersEl.forEach((lazySwiper) => {
    lazySwiperObserver.observe(lazySwiper);
});
